import { m } from 'framer-motion';
import { IKLink } from '@/components/shared/material';

interface RelatedArticleProps {
  heading?: string;
  slug?: string;
  imageUrl?: string;
  articleTitle?: string;
  industryColor?: string;
  spotlightInView?: boolean;
}

export default function RelatedArticle({
  heading,
  slug,
  imageUrl,
  articleTitle,
  industryColor,
  spotlightInView,
}: RelatedArticleProps) {
  return (
    <div className='z-10 col-span-1 flex h-full flex-col justify-between gap-4 pb-4'>
      <h3
        className={`heading-md font-display font-semibold tracking-tighter ${industryColor === 'white' || industryColor === 'yellow' ? 'text-[#282825]' : 'text-white drop-shadow-lg'}`}
      >
        {heading}
      </h3>
      <m.div
        initial={{ opacity: 0, y: 40 }}
        animate={spotlightInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
        whileHover={{
          scale: 1.02,
          transition: { duration: 0.2, ease: 'easeInOut', delay: 0 }, // no delay here
        }}
        transition={{
          opacity: { duration: 0.3, delay: 0.4 },
          y: { duration: 0.3, delay: 0.4 },
        }}
        className='hidden lg:block'
      >
        {slug && (
          <IKLink
            link={{
              url: `blog/${slug}`,
              type: 'internal',
              document: 'page',
            }}
          >
            <div
              className='group flex h-96 items-end justify-center rounded-2xl p-4'
              style={{
                backgroundImage: `url(${imageUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            >
              <div className='w-full rounded-xl border border-gray-400 bg-gray-600 bg-opacity-20 p-3 text-xl backdrop-blur-md duration-200 group-hover:bg-opacity-40'>
                <h3 className='line-clamp-2'>{articleTitle}</h3>
              </div>
            </div>
          </IKLink>
        )}
      </m.div>
      <m.div
        whileHover={{
          scale: 1.02,
          transition: { duration: 0.2, ease: 'easeInOut', delay: 0 }, // no delay here
        }}
        className='block lg:hidden'
      >
        {slug && (
          <IKLink
            link={{
              url: `blog/${slug}`,
              type: 'internal',
              document: 'page',
            }}
          >
            <div
              className='group flex h-96 items-end justify-center rounded-2xl p-4'
              style={{
                backgroundImage: `url(${imageUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            >
              <div className='w-full rounded-xl border border-gray-400 bg-gray-600 bg-opacity-20 p-3 text-xl backdrop-blur-md duration-200 group-hover:bg-opacity-40'>
                <h3 className='line-clamp-2'>{articleTitle}</h3>
              </div>
            </div>
          </IKLink>
        )}
      </m.div>
    </div>
  );
}
